module.exports = __webpack_public_path__ + "static/basilisk-90d15211fc76ff3e4a75dc7fe6c576c5.jpg";